import { Modal, ModalBody, ModalHeader } from "flowbite-react"
import { Phone } from "iconoir-react"
import React from "react"
import { settings } from "@/settings"

export default function DemoCallModal({
  showModal,
  setShowModal
}: {
  showModal: boolean
  setShowModal: (show: boolean) => void
}): React.JSX.Element {
  const onClose = () => {
    setShowModal(false)
    window.localStorage.setItem("show_demo_modal", "false")
    console.log("Set show_demo_modal to false")
  }

  return (
    <>
      <Modal show={showModal} onClose={() => onClose()} className="pt-safe">
        <ModalHeader className="border-b border-gray-200">
          <span className="text-purple-600 text-xl font-bold">Experience AI's Next Evolution</span>
        </ModalHeader>
        <ModalBody>
          <div className="flex flex-col text-center">
            <div className="mx-auto w-fit p-3 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-xl shadow-lg mb-4">
              <Phone className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-gray-800">Want to talk to the AI yourself?</h2>
            <p className="text-sm md:text-base text-gray-500 mt-1 max-w-xl mx-auto">
              Experience the magic firsthand. Call our AI for a mind-bending conversation. It's a fun glimpse into the
              future of AI voices.
            </p>
            <div className="mt-4">
              <div className="inline-block bg-gray-100 rounded-lg px-4 py-3">
                <a
                  href={`tel:${settings.DEMO_PHONE_NUMBER_TEL}`}
                  className="text-lg md:text-xl font-mono text-gray-700 tracking-wider hover:underline focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 rounded"
                >
                  {settings.DEMO_PHONE_NUMBER}
                </a>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}
